import {
  FETCHING_ASSETS_COUNT,
  FETCHING_ASSETS_COUNT_SUCCEEDED,
  FETCHING_ASSETS_COUNT_FAILED,
  FETCHING_ADMIN_USERS_FOR_ACCOUNT,
  FETCHING_ADMIN_USERS_FOR_ACCOUNT_SUCCEEDED,
  FETCHING_ADMIN_USERS_FOR_ACCOUNT_FAILED,
} from "constants/actionTypes";
import { Search } from "semantic-ui-react";

const initState = {
  count: {
    all: {
      fetching: false,
      total: 0,
      error: null,
    },
  },
  adminUser: {
    loading: false,
    list: [],
    error: null,
  },
};

function assetsReducer(state = initState, action) {
  switch (action.type) {
    // ----- Assets Count -----
    case FETCHING_ASSETS_COUNT:
      return {
        ...state,
        count: {
          ...state.count,
          all: { fetching: true, total: 0, error: null },
        },
      };

    case FETCHING_ASSETS_COUNT_SUCCEEDED:
      return {
        ...state,
        count: {
          ...state.count,
          all: { fetching: false, total: action.payload, error: null },
        },
      };

    case FETCHING_ASSETS_COUNT_FAILED:
      return {
        ...state,
        count: {
          ...state.count,
          all: {
            fetching: false,
            total: 0,
            error:
              action.payload && action.payload.errors
                ? action.payload.errors[0].message
                : null,
          },
        },
      };

    // ----- Admin Users -----
    case FETCHING_ADMIN_USERS_FOR_ACCOUNT:
      return {
        ...state,
        adminUser: { ...state.adminUser, loading: true, error: null },
      };

    case FETCHING_ADMIN_USERS_FOR_ACCOUNT_SUCCEEDED:
      return {
        ...state,
        adminUser: { loading: false, list: action.payload, error: null },
      };

    case FETCHING_ADMIN_USERS_FOR_ACCOUNT_FAILED:
      return {
        ...state,
        adminUser: {
          loading: false,
          list: [],
          error: action.payload || "Failed to fetch admin users",
        },
      };

    default:
      return state;
  }
}

export { assetsReducer };
